var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"gc_main",staticStyle:{"overflow":"hidden","height":"100%"}},[_c('button',{staticClass:"left-button",on:{"click":_vm.back}},[_vm._v("返回游戏")])])
}
var staticRenderFns = []

export { render, staticRenderFns }